import React, {useContext} from 'react';
import {PriceFormat} from '../common';
import {StaticData} from '../context/staticData';
import getCloudImageUrl from '../helpers/getCloudImageUrl';

export default function VehicleCard({vehicle}) {
    const {images, price, attributes, url, brand, model, type, enrichedValues} = vehicle;
    const {
        customOptions: {vehicleSpecs},
        placeholderUrl,
    } = useContext(StaticData);

    const specs = Array.isArray(vehicleSpecs) ? vehicleSpecs : vehicleSpecs.split(',');

    let vehicleImageUrl = placeholderUrl;
    let vehicleImageDescription = 'Afbeeldingen binnenkort beschikbaar';

    images.map((image) => {
        if (image.filter === 'vehicle_image' && image.position === 1) {
            vehicleImageUrl = getCloudImageUrl(image.path, {width: 520, height: 390});
            vehicleImageDescription = image.description;
        }
    });

    const activePrice = attributes.actieprijs && attributes.actieprijs.value > 0
        ? attributes.actieprijs.value
        : price;

    return (
        <a
            className="card card--product"
            href={url}
            title={`${brand} ${model} ${type}`}>
            <div className="card__header">
                <img className="card__image img-fluid" src={vehicleImageUrl} alt={vehicleImageDescription} width="1024" height="768" loading="lazy" />
            </div>
            <div className="card__content">
                <div className="card__text-group">
                    <h5 className="card__title">{brand} {model}</h5>
                    <p className="card__description">{type}</p>
                </div>
                <div className="card__details">
                    {specs.map((spec, index) => (
                        typeof attributes[spec] !== 'undefined' && (
                            <span className="card__detail-pill" key={index}>
                                {attributes[spec].code === 'tellerstand'
                                    ? `${attributes[spec].value.toLocaleString('nl-BE')} km`
                                    : attributes[spec].value}
                            </span>
                        )
                    ))}
                </div>
                <div className="card__price-row">
                    <span className="card__price">
                        <PriceFormat value={activePrice} />
                    </span>
                    {enrichedValues.finance_price && enrichedValues.finance_price > 0 && (
                        <>
                            <span className="card__price-divider">of</span>
                            <span className="card__price">
                                <PriceFormat value={enrichedValues.finance_price} /> p/m
                            </span>
                        </>
                    )}
                </div>
            </div>
        </a>
    );
}
